import { Link } from 'react-router-dom'
import { Icon } from './Icon'
import { useAsync } from '../lib/useAsync'
import { useLiveRefresh } from '../lib/useLiveRefresh'
import { api } from '../api/client'

/** Midnight tonight and midnight tomorrow, as the officer's own clock reads them. */
function today(): { start: string; end: string } {
  const start = new Date()
  start.setHours(0, 0, 0, 0)
  const end = new Date(start)
  end.setDate(end.getDate() + 1)
  return { start: start.toISOString(), end: end.toISOString() }
}

function clock(iso: string): string {
  return new Date(iso).toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' })
}

/** Today's meetings, above the goals card.
 *
 *  Shown only when there is something on it, or when a calendar is connected and
 *  the day is genuinely clear — an empty card on a screen nobody has connected a
 *  calendar to is just furniture. */
export function ScheduleCard() {
  const { data, reload } = useAsync(() => api.appointments(today()), [])
  useLiveRefresh(reload)
  if (!data) return null

  const { appointments, calendar } = data
  if (!appointments.length && !calendar.connected) return null

  const now = Date.now()

  return (
    <div className="card">
      <div className="card-head">
        <h2 className="h2" style={{ fontSize: 14.5 }}>Today’s schedule</h2>
        <span className="spacer" />
        {calendar.connected ? (
          <span className="quiet" style={{ fontSize: 11.5 }} title={`Syncing with ${calendar.email}`}>
            <Icon name="event_available" size={13} style={{ verticalAlign: -2 }} /> Google
          </span>
        ) : null}
      </div>
      <div className="card-body" style={{ paddingTop: 0 }}>
        {appointments.length === 0 ? (
          <p className="quiet" style={{ fontSize: 12.5, margin: 0 }}>Nothing booked today.</p>
        ) : (
          <ul style={{ listStyle: 'none', margin: 0, padding: 0 }}>
            {appointments.map((a) => {
              const done = new Date(a.ends_at).getTime() < now
              const target = a.href
              const line = (
                <>
                  <span className="mono" style={{ fontSize: 12.5, minWidth: 66, flexShrink: 0 }}>
                    {a.all_day ? 'All day' : clock(a.starts_at)}
                  </span>
                  <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                    {a.title}
                    {a.contact_name ? <span className="quiet"> · {a.contact_name}</span> : null}
                  </span>
                </>
              )
              return (
                <li key={a.id} style={{
                  display: 'flex', gap: 10, alignItems: 'baseline', padding: '6px 0',
                  fontSize: 13, opacity: done ? 0.5 : 1,
                }}>
                  {target ? <Link to={target} style={{ display: 'contents' }}>{line}</Link> : line}
                </li>
              )
            })}
          </ul>
        )}
      </div>
    </div>
  )
}
